import { __decorate, __metadata, __param } from "tslib";
import { smoothScroll } from '@gn-audio/ui/tools/smooth-srcoll';
import { Directive, Inject, Input } from 'angular-ts-decorators';
var ScrollToOnLoadDirective = (function () {
    function ScrollToOnLoadDirective($element) {
        this.$element = $element;
    }
    ScrollToOnLoadDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (document.referrer.indexOf('supportpages/') > -1) {
            setTimeout(function () { smoothScroll(_this.$element[0]); }, 500);
        }
        else {
            return;
        }
    };
    ScrollToOnLoadDirective.$inject = ['$element'];
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ScrollToOnLoadDirective.prototype, "scrollToOnLoad", void 0);
    ScrollToOnLoadDirective = __decorate([
        Directive({
            selector: '[scrollToOnLoad]',
        }),
        __param(0, Inject('$element')),
        __metadata("design:paramtypes", [Object])
    ], ScrollToOnLoadDirective);
    return ScrollToOnLoadDirective;
}());
export { ScrollToOnLoadDirective };
